import { render, staticRenderFns } from "./SettingsStatistic.vue?vue&type=template&id=3b2aa416&scoped=true&"
import script from "./SettingsStatistic.vue?vue&type=script&lang=ts&"
export * from "./SettingsStatistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2aa416",
  null
  
)

export default component.exports